import { useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useUpdateEffect } from 'ahooks'
import { getOrderCreateInputSelector, setOrderProductVariants } from 'store/features/booking/OrderCreateInput'
import { sagaActions } from 'store/sagas/typeSagas'
import { getDateFormat } from 'config/helpers'

const useDatePicker = () => {
  const dispatch = useDispatch()
  const orderDetail = useSelector(getOrderCreateInputSelector)
  // storeの中の予約日が変更するとDatePickerの内容を同時に更新する
  const storeDate = useMemo(() => {
    return {
      start: orderDetail.bookingDate.start,
      end: orderDetail.bookingDate.end,
    }
  }, [orderDetail])

  const [startDate, setStartDate] = useState(
    storeDate.start
      ? typeof storeDate.start == 'string'
        ? new Date(storeDate.start)
        : storeDate.start
      : null
  )
  const [endDate, setEndDate] = useState(
    storeDate.end
      ? typeof storeDate.end == 'string'
        ? new Date(storeDate.end)
        : storeDate.end
      : null
  )

  // fixed values of datepicker become 1970/01/01 when date dosenot exist
  useUpdateEffect(() => {
    const s = orderDetail?.bookingDate?.start
    const e = orderDetail?.bookingDate?.end
    setStartDate(s ? new Date(s) : null)
    setEndDate(e ? new Date(e) : null)
  }, [orderDetail?.bookingDate])

  useEffect(() => {
    if (startDate === null) return

    dispatch({
      type: sagaActions.UPDATE_ORDER_START_DATES,
      payload: getDateFormat(startDate.toString()),
    })
  }, [startDate]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (endDate === null) return

    dispatch({
      type: sagaActions.UPDATE_ORDER_END_DATES,
      payload: getDateFormat(endDate.toString()),
    })
  }, [endDate]) // eslint-disable-line react-hooks/exhaustive-deps

  const setOrderStartDates = (date) => {
    // 利用予定日が変更されたら選択中の施設及びバリエーションをリセットする
    dispatch(setOrderProductVariants([]))

    setStartDate(date)
    if (endDate === null) setEndDate(date)
  }

  const setOrderEndDates = (date) => {
    // 利用予定日が変更されたら選択中の施設及びバリエーションをリセットする
    dispatch(setOrderProductVariants([]))

    setEndDate(date)
    if (startDate === null) setStartDate(date)
  }

  return {
    startDate,
    endDate,
    setOrderStartDates,
    setOrderEndDates,
  }
}

export default useDatePicker
